import { useState } from "react";
import { Play } from "lucide-react";
import { mediaUrl, thumbUrl } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { embedUrl } from "./HeaderMedia";

// The video's own still (when we have one) under a play button.
export const VideoStill = ({ video, size = 56 }) => (
  <>
    {video?.thumbnail && (
      <>
        <img src={mediaUrl(thumbUrl(video.thumbnail))} alt="" loading="lazy" decoding="async" data-testid="video-still-img"
          style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
        <span aria-hidden="true" style={{ position: "absolute", inset: 0, background: "rgba(20, 35, 42, .25)" }} />
      </>
    )}
    <span style={{ position: "relative", width: size, height: size, borderRadius: "50%", background: "#fff", color: "#14232a", display: "flex",
      alignItems: "center", justifyContent: "center", boxShadow: "0 4px 14px rgba(0, 0, 0, .25)" }}>
      <Play size={Math.round(size * 0.4)} fill="currentColor" />
    </span>
  </>
);

const Tile = ({ item, index, onOpen }) => {
  const isVideo = item.type === "video_link";
  const label = isVideo ? "Video" : "Photo";
  return (
    <figure className="tile" style={{ margin: 0 }}>
      <button type="button" onClick={onOpen} aria-label={`Open ${label}: ${item.caption || `item ${index + 1}`}`} data-testid={`gallery-item-${index}`}
        style={{ display: "block", width: "100%", padding: 0, border: "none", borderRadius: 12, overflow: "hidden", cursor: "pointer", background: "transparent" }}>
        <div className="tile-media" style={{ position: "relative", aspectRatio: "4 / 3", background: isVideo ? "#1f3540" : "#e4ecef",
          display: "flex", alignItems: "center", justifyContent: "center" }}>
          {isVideo ? (
            <VideoStill video={item.video} />
          ) : (
            <img src={mediaUrl(thumbUrl(item.url))} alt="" loading="lazy" decoding="async" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          )}
          <span className="media-badge" style={{ left: 10, bottom: 10, fontSize: 12, padding: "4px 9px" }}>{label}</span>
        </div>
      </button>
      {item.caption && <figcaption style={{ fontSize: 14, lineHeight: 1.45, color: "var(--muted)", marginTop: 10 }}>{item.caption}</figcaption>}
    </figure>
  );
};

export const Gallery = ({ items }) => {
  const [open, setOpen] = useState(null);
  const item = open != null ? items[open] : null;
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 24 }} data-testid="gallery">
        {items.map((g, i) => <Tile key={`${g.url}-${i}`} item={g} index={i} onOpen={() => setOpen(i)} />)}
      </div>
      <Dialog open={!!item} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent style={{ maxWidth: 960, width: "calc(100vw - 32px)", padding: 16, borderRadius: 16 }} data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{item?.caption || "Gallery item"}</DialogTitle>
          {item && (
            <div>
              <div style={{ position: "relative", aspectRatio: item.type === "video_link" ? "16 / 9" : "auto", background: "#14232a", borderRadius: 10, overflow: "hidden" }}>
                {item.type === "video_link" ? (
                  <iframe title={item.caption || "Video"} src={embedUrl(item.video)} allow="autoplay; fullscreen" allowFullScreen
                    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 }} data-zoomable="" />
                ) : (
                  <img src={mediaUrl(item.url)} alt={item.caption || ""} style={{ width: "100%", maxHeight: "75vh", objectFit: "contain", margin: "0 auto" }} data-zoomable="" />
                )}
              </div>
              {item.caption && <p style={{ margin: "12px 4px 0", fontSize: 15, color: "var(--body)" }}>{item.caption}</p>}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
